spApp.filter('allowHtml', ['$sce', function ($sce) {
  return (text) => {
    return $sce.trustAsHtml(text);
  };
}]);